import * as React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import {useSelector} from "react-redux";


export default function MediaCard( {souscriptionImage} ) {
    const token = useSelector((state) => state.auth.login.referentielToken);
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' ,backgroundColor:'hsl(208deg 100% 97.06%)'}}>
            <Card sx={{ maxWidth: 791 }}>
                <CardMedia
                    component="img"
                    height="550"
                    image={souscriptionImage}
                    alt="Descriptive Alt Text"
                />
            </Card>
        </div>
    );
}